(() => {
  const desktop = window.matchMedia('(min-width: 750px)');

  const syncColumns = () => {
    document.querySelectorAll('[data-cf-col]').forEach((column) => {
      column.open = desktop.matches;
    });
  };

  const blockDesktopToggle = (event) => {
    if (desktop.matches && event.target.closest('[data-cf-col] > summary')) event.preventDefault();
  };

  const setupCookieButton = () => {
    const button = document.querySelector('[data-cf-cookie]');
    if (!button) return;
    const banner = window.privacyBanner;
    const fallback = button.dataset.fallback;
    if (banner && typeof banner.showPreferences === 'function') {
      button.hidden = false;
      button.addEventListener('click', () => banner.showPreferences());
    } else if (fallback) {
      button.hidden = false;
      button.addEventListener('click', () => {
        window.location.href = fallback;
      });
    }
  };

  const init = () => {
    syncColumns();
    setupCookieButton();
  };

  document.addEventListener('click', blockDesktopToggle);
  desktop.addEventListener('change', syncColumns);
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
